import { DASHCOLORS } from 'bd-web-components'
import styled from 'styled-components'

export const TextTableCategory = styled.div`
  margin-top: 0px;
  color: ${DASHCOLORS.PRIMARY_BLUE_02};
  /* border-bottom: 2px solid ${DASHCOLORS.GRAY_SCALE_09}; */
  padding-bottom: 8px;
  font-weight: 400;
  font-size: 12px;
  line-height: 14.5px;
  @media (max-width: 768px) {
    font-size: 10px;
    line-height: 13px;
  }
`
export const TextLinkTableCategory = styled.a`
  margin-top: 0px;
  color: ${DASHCOLORS.PRIMARY_BLUE_03};
  padding-bottom: 8px;
  width: 100%;
  font-weight: 600;
  font-size: 12px;
  line-height: 14.5px;
  text-decoration: none;
  @media (max-width: 768px) {
    font-size: 10px;
    line-height: 13px;
  }
`

export const TextDescriptionContainer = styled.div`
  width: 100%;
  display: flex;
  gap: 16px;
  a {
    text-decoration: underline;
    cursor: pointer;
  };
`